/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { noop } from 'lodash';

export interface VisibilityFilterChangeEvent {
  checked: boolean;
}

@Component({
  selector: 'gh-visibility-filter',
  template: require('./visibility-filter.component.html'),
  styles: [require('./visibility-filter.component.scss')],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: VisibilityFilterComponent, multi: true }],
})
export class VisibilityFilterComponent implements ControlValueAccessor {
  @Input() checked: boolean;
  @Input() disabled: boolean = false;

  // tslint:disable-next-line:no-output-named-after-standard-event
  @Output() change = new EventEmitter<VisibilityFilterChangeEvent>();

  private _onChange: Function = noop;
  private _onTouched: Function = noop;

  onChange(checked: boolean): void {
    this.checked = checked;

    this._onChange(checked);
    this._onTouched(checked);
    this.change.emit({ checked });
  }

  writeValue(obj: any): void {
    this.checked = obj;
  }

  registerOnChange(fn: any): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
